import { render, staticRenderFns } from "./VideoRoomChat.vue?vue&type=template&id=0646ab84&scoped=true&"
import script from "./VideoRoomChat.vue?vue&type=script&lang=js&"
export * from "./VideoRoomChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomChat.vue?vue&type=style&index=0&id=0646ab84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646ab84",
  null
  
)

/* custom blocks */
import block0 from "./VideoRoomChat.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoRoomChat.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports